module.exports = __webpack_public_path__ + "401f042388942ab1f367f6640c188dd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fossil-fuel-bonds-social-share.png
// module id = 581
// module chunks = 0